import React from 'react';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Sarah Johnson',
  role: 'Marketing Director',
  company: 'TechFlow Inc.',
  content: "The quality of the prints is outstanding. We've used several vendors in the past, but Liberty Screen Printing is by far the most consistent and professional.",
  stars: 5
}, {
  name: 'Mike Peters',
  role: 'Event Organizer',
  company: 'City Marathon',
  content: 'We needed 500 shirts in a rush for our annual charity run. They delivered two days early and the print quality was perfect. Lifesavers!',
  stars: 5
}, {
  name: 'Jessica Chen',
  role: 'Owner',
  company: 'Bean & Brew Coffee',
  content: "Our staff uniforms look amazing. The team helped us choose the right fabric that's durable but breathable for our baristas. Highly recommend.",
  stars: 5
}];
export function Testimonials() {
  return <section id="testimonials" className="py-24 bg-stone-50" data-id="element-190">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-191">
        <div className="text-center mb-16" data-id="element-192">
          <h2 className="text-red-600 font-semibold tracking-wide uppercase text-sm mb-3" data-id="element-193">
            Client Stories
          </h2>
          <h3 className="text-3xl md:text-4xl font-bold text-blue-900" data-id="element-194">
            Trusted by Local Businesses
          </h3>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-195">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-196">
              <div className="flex text-yellow-400 mb-6" data-id="element-197">
                {[...Array(testimonial.stars)].map((_, i) => <Star key={i} className="h-5 w-5 fill-current" data-id="element-198" />)}
              </div>
              <div className="flex-grow" data-id="element-199">
                <Quote className="h-8 w-8 text-blue-100 mb-4" data-id="element-200" />
                <p className="text-gray-700 italic mb-6 leading-relaxed" data-id="element-201">
                  "{testimonial.content}"
                </p>
              </div>
              <div className="flex items-center mt-4 pt-4 border-t border-gray-100" data-id="element-202">
                <div className="h-10 w-10 rounded-full bg-blue-900 flex items-center justify-center text-white font-bold text-sm mr-3" data-id="element-203">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-204">
                  <h4 className="font-bold text-gray-900 text-sm" data-id="element-205">
                    {testimonial.name}
                  </h4>
                  <p className="text-gray-500 text-xs" data-id="element-206">
                    {testimonial.role}, {testimonial.company}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}